import { Location, Maybe } from '@gql/schema';
import { IPageName, getPath } from '@secretescapes/cauldron';
import { notEmpty } from '@features/AvailabilityPresentation/AvailabilityPresentation.utils';

export const getSearchHref = (label: string, territoryCode: string) => {
  return `${getPath(IPageName.searchResults, territoryCode)}?query=${encodeURIComponent(label)}`;
};

export const getBreadcrumb = (label: Maybe<string>, href: Maybe<string>, isDuplicate = false) => {
  if (!label || !href || isDuplicate) {
    return undefined;
  }

  return {
    label,
    href,
  };
};

export const getBreadcrumbs = (homeLabel: string, location: Location, territoryCode: string) => {
  const { city, continent, country, division } = location;

  const items = [
    getBreadcrumb(homeLabel, getPath(IPageName.currentSales, territoryCode)),
    getBreadcrumb(continent?.name, getSearchHref(continent?.name ?? '', territoryCode)),
    getBreadcrumb(country?.name, getSearchHref(country?.name ?? '', territoryCode)),
    getBreadcrumb(
      division?.name,
      getSearchHref(`${division?.name}, ${country?.name ?? ''}`, territoryCode)
    ),
    getBreadcrumb(
      city?.name,
      getSearchHref(`${city?.name}, ${country?.name ?? ''}`, territoryCode),
      city?.name?.toLowerCase() === division?.name?.toLowerCase()
    ),
  ];

  return items.filter(notEmpty);
};
